import { createContext, useContext } from "react";

import { CouponsState } from "features/Coupons/types";

export const CouponsContext = createContext<CouponsState | null>(null);

export const useCouponsContext = (): CouponsState => {
    const state = useContext(CouponsContext);

    if (!state) {
        throw new Error("useCouponsContext должен использоваться внутри Coupons");
    }

    return state;
};
